import { Avatar, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { CommentDTO } from '@/types/models';
import timeAgo from '@/utils/timeAgo';
const CommentCard = (props: CommentDTO & {
  isAdmin?: boolean;
}) => {
  return <Grid container sx={{
    width: '100%',
    flexDirection: 'column',
    rowGap: 'var(--spacing_m)',
    paddingLeft: props.isAdmin ? 'var(--spacing_m_nudge)' : 0
  }} data-sentry-element="Grid" data-sentry-component="CommentCard" data-sentry-source-file="CommentCard.tsx">
      <Box sx={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--spacing_xs)'
    }} data-sentry-element="Box" data-sentry-source-file="CommentCard.tsx">
        {props.isAdmin ? <Avatar sx={{
        width: 24,
        height: 24,
        fontSize: 14
      }} src={'/images/zeema-logo-circle.png'}>
            {props.authorName?.slice(0, 1)}
          </Avatar> : <Typography sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        border: '1px solid',
        borderColor: 'stroke.stroke3',
        bgcolor: 'background.bg3',
        borderRadius: 'var(--corner_radius_circular)'
      }} color={'text.text2'} variant='bodyStrong__Wallfund'>
            {props.authorName.slice(0, 1)}
          </Typography>}

        {props.isAdmin ? <Box sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--spacing_xs)'
      }}>
            <Typography variant='bodyMedium__Wallfund'>شرکت زیما</Typography>{' '}
            {/* <VerifiedCheck /> */}
          </Box> : <Typography variant='bodyMedium__Wallfund' flex={1}>
            {props.authorName + ' ' + props.authorLastName}
          </Typography>}
        {props.createdAt && <Typography variant='bodyMedium__Wallfund' color='text.text2'>
            {props.createdAt && timeAgo(new Date(props.createdAt), 'medium')}
          </Typography>}
      </Box>
      <Typography variant='bodyMedium__Wallfund' sx={{
      borderRadius: 'var(--corner_radius_m)',
      padding: 'var(--spacing_s)',
      backgroundColor: props.isAdmin ? 'background.bg5' : 'background.bg2',
      textAlign: 'justify'
    }} data-sentry-element="Typography" data-sentry-source-file="CommentCard.tsx">
        {props.content}
      </Typography>
    </Grid>;
};
export default CommentCard;